import { colors } from '../../../../../../../colorVars';
import { useWebsocketStore } from '../../../../../../../stores/websocketStore/websocketProvider';
import ApplyRounding from '../../../../../../../utils/math/ApplyRounding';
import { Body3 } from '../../../../../../atomic/text/Text';

type Props = {
  tradePlanId: string;
};

export const PnLComponent = ({ tradePlanId }: Props) => {
  const { tradePlanStore } = useWebsocketStore();
  const position = tradePlanStore.getTradePlanPosition(tradePlanId);
  const unrealizedPnl = position?.uPnlAtBidAsk ?? null;
  const realizedPnl = position?.realizedPnl ?? null;
  return (
    <div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr' }}>
        <Body3 color={colors.lightGrey} fontWeight={700}>
          uPnL:{' '}
        </Body3>
        <Body3
          color={
            unrealizedPnl == null
              ? colors.lightGrey
              : Number(unrealizedPnl) > 0
              ? colors.green
              : Number(unrealizedPnl) < 0
              ? colors.red
              : colors.lightGrey
          }
          fontWeight={500}
          margin="0 5px 0 0"
        >
          {unrealizedPnl == null ? '--' : `$${ApplyRounding(Math.abs(unrealizedPnl), 2)}`}
        </Body3>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr' }}>
        <Body3 color={colors.lightGrey} fontWeight={700}>
          rPnL:{' '}
        </Body3>
        <Body3
          color={
            realizedPnl == null
              ? colors.lightGrey
              : Number(realizedPnl) > 0
              ? colors.green
              : Number(realizedPnl) < 0
              ? colors.red
              : colors.lightGrey
          }
          fontWeight={500}
        >
          {realizedPnl == null ? '--' : `$${ApplyRounding(Math.abs(realizedPnl), 2)}`}
        </Body3>
      </div>
    </div>
  );
};
